export type InstanceJwtPayload = {
  surveyResponseId?: string;
};

/** Decoded JWT payload before field validation. */
type RawInstanceJwtPayload = {
  surveyResponseId?: string;
};

/**
 * Decode the payload segment of an instance JWT without verification.
 */
export function decodeInstanceJwt(instanceId: string): InstanceJwtPayload | null {
  const token = instanceId.trim();
  if (!token) return null;

  const parts = token.split('.');
  if (parts.length < 2) return null;

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = atob(padded);
    const parsed = JSON.parse(json);

    if (typeof parsed !== 'object' || parsed === null) {
      return null;
    }

    const payload = parsed as RawInstanceJwtPayload;
    const surveyResponseId =
      typeof payload.surveyResponseId === 'string' ? payload.surveyResponseId : undefined;

    return { surveyResponseId };
  } catch {
    return null;
  }
}
